import { styled, theme } from 'ui/theme';

export const Badge = {
  Circle: styled('div')`
    height: ${theme.sizes[2]};
    width: ${theme.sizes[2]};
    border-radius: 100%;
    background: ${theme.colors.assorted[9]};
    position: absolute;
    right: 0;
  `,
  Wrapper: styled('div')`
    position: relative;
  `,
};
